/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EvaluationScopeCategory = {
    Undefined: 'Undefined',
    PhotonWff: 'PhotonWff',
    PhotonFff: 'PhotonFff',
    Electron: 'Electron'
} as const;
export type EvaluationScopeCategory = typeof EvaluationScopeCategory[keyof typeof EvaluationScopeCategory];


export function EvaluationScopeCategoryFromJSON(json: any): EvaluationScopeCategory {
    return EvaluationScopeCategoryFromJSONTyped(json, false);
}

export function EvaluationScopeCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvaluationScopeCategory {
    return json as EvaluationScopeCategory;
}

export function EvaluationScopeCategoryToJSON(value?: EvaluationScopeCategory | null): any {
    return value as any;
}

/**
 * Check if a given object implements the EvaluationScopeCategory interface.
 */
 export function instanceOfEvaluationScopeCategory(value: any): value is EvaluationScopeCategory {
    return Object.values(EvaluationScopeCategory).includes(value)
}

